<template>
  <span>
    {{ label }}
  </span>
</template>
<script>
export default {
  name: "BadgeComponent",
  props: {
    label: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/field.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/color.scss";

.badge-outline {
  border-radius: 5px;
  padding: 3px 10px;
  text-align: center;
  font-size: $font-size-xs;
  font-weight: 600;
  width: fit-content;
  margin: 0;

  &-warning-outline {
    background-color: #fef0b9;
    color: #bc9102;
  }
  &-success-outline {
    background-color: #d0f4e8;
    color: #22a77c;
  }
  &-error-outline {
    background-color: #ffe1e7;
    color: #c44f63;
  }
}

.badge-neon {
  margin: 0;
  border-radius: 3px;
  padding: 2px 10px;
  text-align: center;
  font-size: $font-size-xs;
  font-weight: 700;
  width: fit-content;
  height: fit-content;

  &-success-outline {
    background-color: #d7f7c2;
    color: #006908;
  }

  &-warning-outline {
    background-color: #fef0b9;
    color: #b18800;
  }

  &-error-outline {
    background-color: #ffe1e7;
    color: #c44f63;
  }

  &-grey-outline {
    background-color: $light-200;
    color: #000000;
  }
}

.badge-lg {
  border-radius: 5px;
  padding: 3px 10px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
  margin: 0;

  &-warning-solid {
    background-color: #faa338;
    color: #ffffff;
  }
  &-success-solid {
    background-color: #27bd68;
    color: #ffffff;
  }
  &-error-solid {
    background-color: #bd2727;
    color: #ffffff;
  }
}

.badge-rounded {
  border-radius: 5px;
  padding: 3px 10px;
  text-align: center;
  font-size: $font-size-xs;
  font-weight: $font-weight-bold;
  width: fit-content;
  height: fit-content;
  margin: 0;

  &-grey-outline {
    background-color: $light-fade-150;
    color: $light-600;
  }

  &-warning-solid {
    background-color: #faa338;
    color: #ffffff;
  }
  &-success-solid {
    background-color: #27bd68;
    color: #ffffff;
  }
  &-error-solid {
    background-color: #bd2727;
    color: #ffffff;
  }
}
</style>
